import { commonServiceSlice } from "../common/commanServiceSlice";
import { fetchSubServices } from "./subServiceThunk";

const subServiceSlice = commonServiceSlice({
  name: "subServices",
  thunk: fetchSubServices,
});

export default subServiceSlice.reducer;
